import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';

export default function Content() {
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={element}
          />
        ))}
        <Route
          path='*'
          element={<Navigate to='/home' />}
        />
      </Routes>
      <Footer>
        Copyright © 2020-{new Date().getFullYear()} {appInfo.company}.
        <br />
        All trademarks or registered trademarks are property of their
        respective owners.
        <br />
        The information presented on these pages is intended only for the person or entity to
        which it is addessed. The pages may contain proprietary, business-confidential
        and/or privileged material. If you are not the intended recipient of this message,
        be aware that any use, review, retransmission, distribution, reproduction or any action
        taken in reliance upon this message is strictly prohibited.
      </Footer>
    </SideNavBarLayout>
  );
}
